/**
 * api_key/v1/api_key.proto
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpContext,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { RpcStatus } from '../model/rpc-status';
// @ts-ignore
import { TokenServiceUpdateTokenBody } from '../model/token-service-update-token-body';
// @ts-ignore
import { V1ClaimTokenResponse } from '../model/v1-claim-token-response';
// @ts-ignore
import { V1GenerateTokenRequest } from '../model/v1-generate-token-request';
// @ts-ignore
import { V1GenerateTokenResponse } from '../model/v1-generate-token-response';
// @ts-ignore
import { V1GetTokenResponse } from '../model/v1-get-token-response';
// @ts-ignore
import { V1ListTokensResponse } from '../model/v1-list-tokens-response';
// @ts-ignore
import { V1RevokeTokenResponse } from '../model/v1-revoke-token-response';
// @ts-ignore
import { V1UpdateTokenResponse } from '../model/v1-update-token-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class TokenServiceService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Customer: Claim a token and receive machine access credentials.
   * Always returns HTTP 200. Business-logic failures (expired, access-window violations, revoked) are surfaced via token.status in the response body rather than 4xx errors. Callers must inspect token.status before using the returned devices. Cross-tenant attempts still return HTTP 403.
   * @endpoint post /v1/claim/{token_string}
   * @param tokenString Token string from URL
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tokenServiceClaimToken(
    tokenString: string,
    body: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<V1ClaimTokenResponse>;
  public tokenServiceClaimToken(
    tokenString: string,
    body: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<V1ClaimTokenResponse>>;
  public tokenServiceClaimToken(
    tokenString: string,
    body: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<V1ClaimTokenResponse>>;
  public tokenServiceClaimToken(
    tokenString: string,
    body: object,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (tokenString === null || tokenString === undefined) {
      throw new Error(
        'Required parameter tokenString was null or undefined when calling tokenServiceClaimToken.',
      );
    }
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling tokenServiceClaimToken.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/claim/${this.configuration.encodeParam({ name: 'tokenString', value: tokenString, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<V1ClaimTokenResponse>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Admin: Generate a new access token
   * @endpoint post /v1/admin/tokens
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tokenServiceGenerateToken(
    body: V1GenerateTokenRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<V1GenerateTokenResponse>;
  public tokenServiceGenerateToken(
    body: V1GenerateTokenRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<V1GenerateTokenResponse>>;
  public tokenServiceGenerateToken(
    body: V1GenerateTokenRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<V1GenerateTokenResponse>>;
  public tokenServiceGenerateToken(
    body: V1GenerateTokenRequest,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling tokenServiceGenerateToken.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/admin/tokens`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<V1GenerateTokenResponse>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Admin: Get token details
   * @endpoint get /v1/admin/tokens/{token_string}
   * @param tokenString
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tokenServiceGetToken(
    tokenString: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<V1GetTokenResponse>;
  public tokenServiceGetToken(
    tokenString: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<V1GetTokenResponse>>;
  public tokenServiceGetToken(
    tokenString: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<V1GetTokenResponse>>;
  public tokenServiceGetToken(
    tokenString: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (tokenString === null || tokenString === undefined) {
      throw new Error(
        'Required parameter tokenString was null or undefined when calling tokenServiceGetToken.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/admin/tokens/${this.configuration.encodeParam({ name: 'tokenString', value: tokenString, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<V1GetTokenResponse>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Admin: List tokens
   * @endpoint get /v1/admin/tokens
   * @param status Filter by status   - TOKEN_STATUS_UNCLAIMED: Token has not been claimed yet.  - TOKEN_STATUS_CLAIMED: Token has been successfully claimed.  - TOKEN_STATUS_EXPIRED: Token has passed its expires_at time. Persisted to DB on detection.  - TOKEN_STATUS_REVOKED: Token has been explicitly revoked by an admin.  - TOKEN_STATUS_NOT_YET_ACTIVE: Claim attempted before access_window_start. Token remains UNCLAIMED in DB.  - TOKEN_STATUS_ACCESS_WINDOW_ENDED: Claim attempted after access_window_end. Token remains UNCLAIMED in DB.
   * @param partnerId
   * @param userId
   * @param pageSize Pagination
   * @param pageToken
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tokenServiceListTokens(
    status?: Array<
      | 'TOKEN_STATUS_UNSPECIFIED'
      | 'TOKEN_STATUS_UNCLAIMED'
      | 'TOKEN_STATUS_CLAIMED'
      | 'TOKEN_STATUS_EXPIRED'
      | 'TOKEN_STATUS_REVOKED'
      | 'TOKEN_STATUS_NOT_YET_ACTIVE'
      | 'TOKEN_STATUS_ACCESS_WINDOW_ENDED'
    >,
    partnerId?: string,
    userId?: string,
    pageSize?: number,
    pageToken?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<V1ListTokensResponse>;
  public tokenServiceListTokens(
    status?: Array<
      | 'TOKEN_STATUS_UNSPECIFIED'
      | 'TOKEN_STATUS_UNCLAIMED'
      | 'TOKEN_STATUS_CLAIMED'
      | 'TOKEN_STATUS_EXPIRED'
      | 'TOKEN_STATUS_REVOKED'
      | 'TOKEN_STATUS_NOT_YET_ACTIVE'
      | 'TOKEN_STATUS_ACCESS_WINDOW_ENDED'
    >,
    partnerId?: string,
    userId?: string,
    pageSize?: number,
    pageToken?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<V1ListTokensResponse>>;
  public tokenServiceListTokens(
    status?: Array<
      | 'TOKEN_STATUS_UNSPECIFIED'
      | 'TOKEN_STATUS_UNCLAIMED'
      | 'TOKEN_STATUS_CLAIMED'
      | 'TOKEN_STATUS_EXPIRED'
      | 'TOKEN_STATUS_REVOKED'
      | 'TOKEN_STATUS_NOT_YET_ACTIVE'
      | 'TOKEN_STATUS_ACCESS_WINDOW_ENDED'
    >,
    partnerId?: string,
    userId?: string,
    pageSize?: number,
    pageToken?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<V1ListTokensResponse>>;
  public tokenServiceListTokens(
    status?: Array<
      | 'TOKEN_STATUS_UNSPECIFIED'
      | 'TOKEN_STATUS_UNCLAIMED'
      | 'TOKEN_STATUS_CLAIMED'
      | 'TOKEN_STATUS_EXPIRED'
      | 'TOKEN_STATUS_REVOKED'
      | 'TOKEN_STATUS_NOT_YET_ACTIVE'
      | 'TOKEN_STATUS_ACCESS_WINDOW_ENDED'
    >,
    partnerId?: string,
    userId?: string,
    pageSize?: number,
    pageToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'status',
      <any>status,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'partner_id',
      <any>partnerId,
      QueryParamStyle.Form,
      false,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'user_id',
      <any>userId,
      QueryParamStyle.Form,
      false,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'page_size',
      <any>pageSize,
      QueryParamStyle.Form,
      false,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'page_token',
      <any>pageToken,
      QueryParamStyle.Form,
      false,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/admin/tokens`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<V1ListTokensResponse>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Admin: Revoke a token
   * @endpoint delete /v1/admin/tokens/{token_string}
   * @param tokenString
   * @param reason
   * @param userId Required: must match the user_id stored on the token.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tokenServiceRevokeToken(
    tokenString: string,
    reason?: string,
    userId?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<V1RevokeTokenResponse>;
  public tokenServiceRevokeToken(
    tokenString: string,
    reason?: string,
    userId?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<V1RevokeTokenResponse>>;
  public tokenServiceRevokeToken(
    tokenString: string,
    reason?: string,
    userId?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<V1RevokeTokenResponse>>;
  public tokenServiceRevokeToken(
    tokenString: string,
    reason?: string,
    userId?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (tokenString === null || tokenString === undefined) {
      throw new Error(
        'Required parameter tokenString was null or undefined when calling tokenServiceRevokeToken.',
      );
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'reason',
      <any>reason,
      QueryParamStyle.Form,
      false,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'user_id',
      <any>userId,
      QueryParamStyle.Form,
      false,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/admin/tokens/${this.configuration.encodeParam({ name: 'tokenString', value: tokenString, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<V1RevokeTokenResponse>('delete', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Admin: Update the validity window of an existing active token. Does not change the token ID or token_string (the shareable URL stays valid).
   * @endpoint patch /v1/admin/tokens/{token_string}
   * @param tokenString
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public tokenServiceUpdateToken(
    tokenString: string,
    body: TokenServiceUpdateTokenBody,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<V1UpdateTokenResponse>;
  public tokenServiceUpdateToken(
    tokenString: string,
    body: TokenServiceUpdateTokenBody,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<V1UpdateTokenResponse>>;
  public tokenServiceUpdateToken(
    tokenString: string,
    body: TokenServiceUpdateTokenBody,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<V1UpdateTokenResponse>>;
  public tokenServiceUpdateToken(
    tokenString: string,
    body: TokenServiceUpdateTokenBody,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (tokenString === null || tokenString === undefined) {
      throw new Error(
        'Required parameter tokenString was null or undefined when calling tokenServiceUpdateToken.',
      );
    }
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling tokenServiceUpdateToken.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/admin/tokens/${this.configuration.encodeParam({ name: 'tokenString', value: tokenString, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<V1UpdateTokenResponse>('patch', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
